import React from 'react';
import PropTypes from 'prop-types';
import withTranslate from 'containers/widgets/withTranslate';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { REFERENCE_LINKS_QUESTION_ID } from '../constants';
import { parseLinks } from '../utils/referenceLinks';
import css from './ConflictDialog.css';

export const CHOICE_THEIRS = 'theirs';
export const CHOICE_YOURS = 'yours';
const CONFLICT_PREFIX = 'STATIC.PAGES.AI_CONTEXT.CONFLICT';

const renderReferenceLinks = (value, translate) => {
    const rows = parseLinks(value);
    if (rows.length === 0) {
        return <span className={css.emptyAnswer}>{translate(`${CONFLICT_PREFIX}.EMPTY_ANSWER`)}</span>;
    }
    return (
        <ul className={css.linkList}>
            {rows.map((row, index) => (
                <li key={index} className={css.linkItem}>
                    <a className={css.linkUrl} href={row.url} target="_blank" rel="noopener noreferrer">
                        {row.url}
                    </a>
                    {row.description && <div className={css.linkDescription}>{row.description}</div>}
                </li>
            ))}
        </ul>
    );
};

const renderAnswer = (questionId, value, translate) => {
    if (questionId === REFERENCE_LINKS_QUESTION_ID) {
        return renderReferenceLinks(value, translate);
    }
    if (!value) return <span className={css.emptyAnswer}>{translate(`${CONFLICT_PREFIX}.EMPTY_ANSWER`)}</span>;
    return <span className={css.answerText}>{value}</span>;
};

const ConflictItem = ({ item, questionTitle, choice, isBaseShown, onChoiceChange, onToggleBase, translate }) => (
    <li className={css.item}>
        <div className={css.itemTitle}>{questionTitle}</div>
        <FormControl component="fieldset" fullWidth>
            <RadioGroup value={choice} onChange={e => onChoiceChange(item.question_id, e.target.value)}>
                <FormControlLabel
                    value={CHOICE_YOURS}
                    control={<Radio size="small" />}
                    label={
                        <div className={css.choice}>
                            <span className={css.choiceLabel}>{translate(`${CONFLICT_PREFIX}.KEEP_YOURS`)}</span>
                            {renderAnswer(item.question_id, item.your_answer, translate)}
                        </div>
                    }
                />
                <FormControlLabel
                    value={CHOICE_THEIRS}
                    control={<Radio size="small" />}
                    label={
                        <div className={css.choice}>
                            <span className={css.choiceLabel}>{translate(`${CONFLICT_PREFIX}.USE_THEIRS`)}</span>
                            {renderAnswer(item.question_id, item.latest_answer, translate)}
                        </div>
                    }
                />
            </RadioGroup>
        </FormControl>
        <button type="button" className={css.baseToggle} onClick={() => onToggleBase(item.question_id)}>
            {translate(isBaseShown ? `${CONFLICT_PREFIX}.HIDE_ORIGINAL` : `${CONFLICT_PREFIX}.SHOW_ORIGINAL`)}
        </button>
        {isBaseShown && (
            <div className={css.baseAnswer}>
                <div className={css.baseLabel}>{translate(`${CONFLICT_PREFIX}.ORIGINAL_LABEL`)}</div>
                {renderAnswer(item.question_id, item.base_answer, translate)}
            </div>
        )}
    </li>
);

ConflictItem.propTypes = {
    item: PropTypes.shape({
        question_id: PropTypes.string.isRequired,
        base_answer: PropTypes.string,
        latest_answer: PropTypes.string,
        your_answer: PropTypes.string,
    }).isRequired,
    questionTitle: PropTypes.string.isRequired,
    choice: PropTypes.string.isRequired,
    isBaseShown: PropTypes.bool.isRequired,
    onChoiceChange: PropTypes.func.isRequired,
    onToggleBase: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withTranslate(ConflictItem);
